import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BlockUIModule } from 'primeng/blockui';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { BlockLoadingComponent as LibBlockLoading } from 'ui-component/src/lib/block-loading/block-loading.component';

@Component({
  selector: 'app-block-loading',
  imports: [CommonModule, ProgressSpinnerModule, BlockUIModule, LibBlockLoading],
  template: `<lib-block-loading
    *ngIf="!custom"
    [show]="show"
    [title]="title"
    [subTitle]="subTitle"
    [custom]="custom"
  ></lib-block-loading> `,
  styleUrls: ['./block-loading.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlockLoadingComponent {
  @Input() show = false;
  @Input() custom = false;
  @Input() title = '';
  @Input() subTitle = '';
}
